import axios from "axios";
import { Base_URL } from "../url";

export const fetchCostCenterMasters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CostCenterMaster/GetAllCostCenters`);
   // const response = await axios.get("https://192.168.29.243:7039/api/CostCenterMaster");
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cost center masters!";
  }
};